import { CourseInsightsRiskLevel } from "@axio/graphql/generated/graphql";
import { colors } from "../../../styles/design-system";

export const formatRiskLabel = (riskLevel: CourseInsightsRiskLevel): string => {
  if (riskLevel === CourseInsightsRiskLevel.AtRisk) return "At Risk";
  if (riskLevel === CourseInsightsRiskLevel.Watch) return "Watch";
  if (riskLevel === CourseInsightsRiskLevel.NoData) return "No Data";
  return "On Track";
};

export const getRiskBadgeStyle = (riskLevel: CourseInsightsRiskLevel) => {
  if (riskLevel === CourseInsightsRiskLevel.AtRisk) {
    return {
      backgroundColor: colors.error[50],
      borderColor: colors.error[200],
      textColor: colors.error[700],
      attentionBorderColor: colors.error[300],
      progressColor: colors.error[500],
      hoverBackgroundColor: colors.error[25],
      hoverBorderColor: colors.error[300],
      hoverTextColor: colors.error[600],
      hoverMetaColor: colors.error[500],
    };
  }

  if (riskLevel === CourseInsightsRiskLevel.Watch) {
    return {
      backgroundColor: colors.warning[50],
      borderColor: colors.warning[200],
      textColor: colors.warning[700],
      attentionBorderColor: colors.warning[300],
      progressColor: colors.warning[500],
      hoverBackgroundColor: colors.warning[25],
      hoverBorderColor: colors.warning[300],
      hoverTextColor: colors.warning[700],
      hoverMetaColor: colors.warning[600],
    };
  }

  if (riskLevel === CourseInsightsRiskLevel.NoData) {
    return {
      backgroundColor: colors.grey[50],
      borderColor: colors.grey[200],
      textColor: colors.grey[700],
      attentionBorderColor: colors.grey[300],
      progressColor: colors.grey[500],
      hoverBackgroundColor: colors.grey[25],
      hoverBorderColor: colors.grey[300],
      hoverTextColor: colors.grey[700],
      hoverMetaColor: colors.grey[600],
    };
  }

  return {
    backgroundColor: colors.success[50],
    borderColor: colors.success[200],
    textColor: colors.success[700],
    attentionBorderColor: colors.success[300],
    progressColor: colors.success[500],
    hoverBackgroundColor: colors.success[25],
    hoverBorderColor: colors.success[300],
    hoverTextColor: colors.success[700],
    hoverMetaColor: colors.success[600],
  };
};
